<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Knitting_Orders' | translateWF: 'Knitting Orders' }}</h1>
        <div class="page__title_buttons">
          @if (canCreate()) {
            <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails()" />
          }
        </div>
      </div>
    </div>

    <p-toggleButton
      [ngModel]="showRollBreakdown()"
      (ngModelChange)="toggleRollBreakdown()"
      [onLabel]="'Knitting_Order_Table_Hide_Roll_Breakdown' | translateWF: 'Hide Roll Breakdown'"
      [offLabel]="'Knitting_Order_Table_Show_Roll_Breakdown' | translateWF: 'Show Roll Breakdown'"
      onIcon="pi-eye-slash"
      offIcon="pi pi-eye"
    />

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Knitting_Orders' | translateWF: 'Knitting Orders'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="knittingorders()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                @if (showRollBreakdown()) {
                  <th style="width: 3rem"></th>
                }
                <th>
                  {{ 'Knitting_Order_Table_Status' | translateWF: 'Status' }}
                </th>
                <th pSortableColumn="knittingOrderNumber">
                  {{ 'Knitting_Order_Table_Knitting_Order_Number' | translateWF: 'Knitting Order Number' }}
                  <p-sortIcon field="knittingOrderNumber"></p-sortIcon>
                </th>
                <th>
                  {{ 'Knitting_Order_Table_Lot_Number' | translateWF: 'Lot Number' }}
                </th>
                <th>
                  {{ 'Knitting_Order_Table_Date_Created' | translateWF: 'Date Created' }}
                </th>
                <th>
                  {{ 'Knitting_Order_Table_Planned_Quantity' | translateWF: 'Planned Quantity' }}
                </th>
                <th>
                  {{ 'Knitting_Order_Table_Issued_Quantity' | translateWF: 'Issued Quantity' }}
                </th>
                <th>{{ 'Knitting_Order_Table_Missing_Quantity' | translateWF: 'Missing Quantity' }}</th>
                <th>{{ 'Knitting_Order_Table_Progress' | translateWF: 'Progress' }}</th>
                <th>{{ 'Knitting_Order_Table_Rolls_Issued' | translateWF: 'Rolls Issued' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-ko>
              <tr class="cursor-pointer" (click)="redirectToDetails(ko.id)">
                @if (showRollBreakdown()) {
                  <td>
                    <p-button
                      type="button"
                      [icon]="isRowExpanded(ko) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                      [rounded]="true"
                      [text]="true"
                      (click)="toggleRowExpansion(ko); $event.stopPropagation()"
                      [disabled]="!ko.rolls || ko.rolls.length === 0"
                    />
                  </td>
                }
                <td>
                  {{ statusOptions[ko.status] }}
                </td>
                <td>
                  <a>{{ ko.knittingOrderNumber }}</a>
                </td>
                <td>
                  {{ getDistinctLotNumbers(ko) }}
                </td>
                <td>{{ ko.createdDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ getPlannedQuantity(ko) | number }}</td>
                <td>
                  <div class="flex flex-col gap-1">
                    <span>{{ ko?.issuedQuantity | number }}</span>
                  </div>
                </td>
                <td>{{ getPlannedQuantity(ko) - (ko?.issuedQuantity || 0) | number }}</td>
                <td>
                  <div class="w-full">
                    <p-progressBar [value]="getProgressPercentage(ko)" [style]="{ height: '16px' }" [styleClass]="getProgressBarClass(ko)"> </p-progressBar>
                  </div>
                </td>
                <td>{{ ko?.rollsWeighed }}</td>
              </tr>
              @if (showRollBreakdown() && isRowExpanded(ko) && ko.rolls && ko.rolls.length > 0) {
                <tr class="expanded-row-content">
                  <td [attr.colspan]="10" class="p-0">
                    <div class="p-3 bg-gray-50">
                      <div class="flex items-center justify-between mb-2">
                        <h6 class="font-semibold">
                          {{ 'Knitting_Order_Table_Rolls_Breakdown' | translateWF: 'Rolls Breakdown' }} ({{ getFilteredRolls(ko).length }}/{{ ko.rolls.length }})
                        </h6>
                        <p-selectButton
                          [options]="[
                            { label: ('Knitting_Order_Table_All' | translateWF: 'All') + ' (' + ko.rolls.length + ')', value: 'all' },
                            {
                              label: ('Knitting_Order_Table_With_Weight' | translateWF: 'With Weight') + ' (' + getRollsWithWeightCount(ko) + ')',
                              value: 'with-weight',
                            },
                            {
                              label: ('Knitting_Order_Table_Without_Weight' | translateWF: 'Without Weight') + ' (' + getRollsWithoutWeightCount(ko) + ')',
                              value: 'without-weight',
                            },
                          ]"
                          [ngModel]="getRollWeightFilter(ko)"
                          (ngModelChange)="setRollWeightFilter(ko, $event)"
                          optionLabel="label"
                          optionValue="value"
                          size="small"
                          (click)="$event.stopPropagation()"
                        />
                      </div>
                      <p-table [value]="getFilteredRolls(ko)" [scrollable]="true" scrollHeight="300px" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                          <tr>
                            <th>{{ 'Knitting_Order_Table_Roll_Number' | translateWF: 'Roll Number' }}</th>
                            <th>{{ 'Knitting_Order_Table_Fabric_Code' | translateWF: 'Fabric Code' }}</th>
                            <th>{{ 'Knitting_Order_Table_Fabric_Description' | translateWF: 'Fabric Description' }}</th>
                            <th>{{ 'Knitting_Order_Table_Item_Code' | translateWF: 'Item Code' }}</th>
                            <th>{{ 'Knitting_Order_Table_Weight_Lbs' | translateWF: 'Weight (lbs)' }}</th>
                            <th>{{ 'Knitting_Order_Table_Planned_Weight' | translateWF: 'Planned Weight' }}</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-roll>
                          <tr>
                            <td>{{ roll.number }}</td>
                            <td>{{ roll.expectedFabricCode }}</td>
                            <td>{{ getFabricDescription(ko, roll.expectedFabricCode) }}</td>
                            <td>{{ roll.itemCode }}</td>
                            <td>{{ getRollWeightInLbs(roll) | number: '1.2-2' }}</td>
                            <td>{{ roll.plannedWeight | number: '1.2-2' }}</td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="6">{{ 'Knitting_Order_Table_No_Rolls' | translateWF: 'No rolls available' }}</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </td>
                </tr>
              }
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="showRollBreakdown() ? 10 : 9">
                  {{ 'NotKnittingOrders' | translateWF: 'Not Knitting Orders found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>

<p-toast position="top-center" />
